import { useMotionValueEvent, useScroll } from 'framer-motion';
import type { RefObject } from 'react';
import { useState } from 'react';

export function useScrollActiveTab(
  divRef: RefObject<HTMLDivElement | null>,
  tabCount: number,
) {
  const { scrollYProgress } = useScroll({
    target: divRef,
    offset: ['start start', 'end end'],
  });

  const [activeTab, setActiveTab] = useState(0);

  useMotionValueEvent(scrollYProgress, 'change', (latest: number): void => {
    setActiveTab((prevTab) => {
      const intervalSize = 1 / tabCount;
      for (let i = 0; i < tabCount; i++) {
        if (latest >= i * intervalSize && latest < (i + 1) * intervalSize) {
          return i;
        }
      }
      return prevTab;
    });
  });

  return activeTab;
}
